import { AddressEndpoints } from "@ADDRESS";
import { useGET } from "@API2";
import { Form, Select } from "antd";
import { useEffect, useState } from "react";
import { URLify } from "@HELPERS";

const { Option } = Select;

const City = (props) => {
  const { data = [], loading } = useGET(`${AddressEndpoints.cities}`, true);
  const [val, setVal] = useState(null);

  useEffect(() => {
    if (!loading) {
      // eğer excelden geliyorsa string gelecek. onu data içerisinde bulup, seçtiriyoruz.
      // urlify ÇANKAYA gibi gelen bir datayı cankaya şekline dönüştürür. Böylece match etmesi kolaylaşır.
      if (typeof props.value === "string") {
        const that = data.find((x) => URLify(x.name) === URLify(props.value));
        if (that) {
          setVal(that.id);
          props.onChange({ id: that.id, name: that.name });
        }
      }
    }
  }, [props, loading]);

  if (loading) {
    return <Select disabled loading placeholder="Yükleniyor..." />;
  }

  return (
    <Select
      onChange={(v) => {
        const current = data.find((x) => x.id === v);
        props.onChange({ id: current.id, name: current.name, forced: true });
        setVal(current.id);
      }}
      loading={loading}
      showSearch
      disabled={props.disabled || false}
      value={val}
      filterOption={(input, option) =>
        option.name.indexOf(input.toLocaleLowerCase("tr")) >= 0
      }
    >
      {data.map((item) => (
        <Option
          key={item.id}
          value={item.id}
          name={item.name.toLocaleLowerCase("tr")}
        >
          {item.name}
        </Option>
      ))}
    </Select>
  );
};

export default City;
